import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { getJob, JobsGet } from '@collections/jobs';
import { Store } from '@ngrx/store';
import { Referral } from '@shared';
import { ReferralService } from '@shared/services/referral.service';
import { Subject, Observable, combineLatest, of } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';

@Component({
  selector: 'mojo-referral-badge',
  templateUrl: './referral-badge.component.html',
  styleUrls: ['./referral-badge.component.scss'],
})
export class ReferralBadgeComponent implements OnInit, OnDestroy {
  @Input()
  candidateId: number;

  allReferralObservable$: Observable<Referral[]>;
  referralList: Referral[] = [];

  constructor(private referralService: ReferralService, private store: Store<{}>) {}

  destroyed$: Subject<boolean> = new Subject();

  ngOnInit(): void {
    this.allReferralObservable$ = this.referralService.get({ url: 'all/', id: this.candidateId });

    this.addingJobTitleToReferral();
  }

  getNameAndEmail(referral: Referral) {
    if (referral)
      return `${referral?.referralFirstName} ${referral?.referralLastName} (${referral?.referralEmail})`;
    else return '';
  }

  addingJobTitleToReferral() {
    this.allReferralObservable$
      .pipe(
        switchMap((referrals: Referral[]) =>
          combineLatest(
            referrals.map((referral) => {
              if (!referral) {
                return of(null);
              }
              const jobId = referral?.jobId;
              if (!jobId) {
                return of({
                  ...referral,
                });
              }
              return this.store.select(getJob(jobId)).pipe(
                switchMap((job) => {
                  if (!!job) {
                    return of({
                      ...referral,
                      jobTitle: job?.title,
                    });
                  } else {
                    this.store.dispatch(new JobsGet({ id: jobId }));
                    return this.store.select(getJob(jobId)).pipe(
                      map((job) => ({
                        ...referral,
                        jobTitle: job?.title ? job?.title : '',
                      })),
                    );
                  }
                }),
              );
            }),
          ).pipe(take(1)),
        ),
      )
      .subscribe((referrals: Referral[]) => {
        this.referralList = referrals;
      });
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
  timedOutCloser;
  mouseEnter(trigger) {
    if (this.timedOutCloser) {
      clearTimeout(this.timedOutCloser);
    }
    trigger.openMenu();
  }

  mouseLeave(trigger) {
    this.timedOutCloser = setTimeout(() => {
      trigger.closeMenu();
    }, 500);
  }
}
